import { createLoadableState } from '@/utils/store/concerns/loadable/state'
import { createMockableState } from '@/utils/store/concerns/mockable/state'

export default () =>
  createLoadableState(
    createMockableState({
      profile: null
    })
  )
